import { useEffect, useState } from 'react'

/**
 * Subscribe to a CSS media query. Returns whether it currently matches and
 * updates on change. Used for the 820px responsive breakpoint (two-pane inbox
 * vs. single-pane list/detail).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    // addEventListener is the modern API; addListener is the Safari<14 fallback.
    if (mql.addEventListener) {
      mql.addEventListener('change', handler)
      return () => mql.removeEventListener('change', handler)
    }
    mql.addListener(handler)
    return () => mql.removeListener(handler)
  }, [query])

  return matches
}

/** True when the viewport is below the 820px inbox breakpoint. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 820px)')
}
